<section class="bg-white p-3 p-lg-4">
   <div class="">
      <header class="d-flex align-items-center justify-content-between gap-3 section-header">
         <h2 class="mb-0 ">Stock News</h2>
      </header>

      <p class="no-data-text">Find out whats happening with this company</p>
      
      <div class="loader-grid" *ngIf="newsLoader">
         <div class="loader-item"  *ngFor="let i of [1,2,3,4,5,6]">
            <div class="skeleton-loader rounded-3 image-loader"></div>
            <div class="d-grid gap-2">
               <span class="skeleton-loader rounded-3 d-block headline-loader"></span>
               <span class="skeleton-loader rounded-3 d-block summary-loader"></span>
               <span class="skeleton-loader rounded-3 d-block summary-loader"></span>
            </div>
         </div>
      </div>
      
      <ng-container *ngIf="!newsLoader && news?.length > 0">
         <div class="news-grid-container">
            <a class="d-block text-decoration-none" *ngFor="let news of getFilteredNews(); trackBy: trackByNewsId" target="_blank" [href]="news.Url">
               <article class="d-flex align-items-start gap-2 gap-lg-3 news-card">
                  <div class="bg-light flex-shrink-0 w-100 overflow-hidden news-image-wrapper">
                     <img class="img-fluid news-image" [appLazyLoadImage]="news.Image" placeholder="/assets/images/dashboard/news-lowres.png" [src]="news.Image" [alt]="news.Headline" *ngIf="news.Image; else noImage">
                     <ng-template #noImage>
                        <img class="img-fluid news-image" appLazyLoadImage="/assets/images/dashboard/stock-news.jpg" placeholder="/assets/images/dashboard/news-lowres.png" [alt]="news.Headline">
                     </ng-template>
                  </div>
                  <div class="flex-grow-1">
                     <h6 class="mb-2 news-headline line-clamp-2">
                        {{ news.Headline }}
                     </h6>
                     <p class="mb-0 news-date">
                        By {{ news.Source }} | {{ formattedDate(news.Datetime) | date : "mediumDate" }}
                     </p>
                  </div>
               </article>
            </a>
         </div>

         <a class="btn d-flex align-items-center justify-content-center mx-auto mt-2 gap-2 text-nowrap p-0 view-all-btn" *ngIf="news?.length > 6" (click)="showNews = !showNews">
            <span>{{ showNews ? 'View Less' : 'View More'  }}</span>
            <!-- <i class="bi bi-arrow-right arrow-icon"></i> -->
         </a>
         
      </ng-container>

      <ng-container *ngIf="!newsLoader && news?.length === 0">
         <p class="no-data-text mb-0 text-center p-5 px-3">No news available for this stock</p>
      </ng-container>

   </div>
</section>





<!-- <div class="stock__main main__box">
   <div class="stock__information">
      <div class="news__header">
         <h2 class="news-title mb-0">Related News</h2>
         
      </div>
      <p class="heading-para mb-0">
         Find out whats happening with this company
      </p>
      <div>
         <ng-container *ngIf="isMobile">
            <div class="mt-lg-4" *ngIf="newsLoader">
               <div class="px-3" *ngFor="let n of [1,2,3,4,5,6]">
                  <ngx-skeleton-loader count="1" appearance="line" animation="progress" [theme]="{ height: '80px', width: '100%', margin: '0px'}"></ngx-skeleton-loader>
               </div>
            </div>
            <ng-container *ngIf="!newsLoader && news?.length">
               <div class="stock" *ngFor="let item of news | reletedNewsChange : showNews">
                  <div class="stocks__news-image">
                     <div
                        class="stock_image"
                        [ngStyle]="{ 'background-image': 'url(' + item.Image + ')' }"
                        *ngIf="item.Image"
                     ></div>
                     <div class="d-flex align-items-center justify-content-center no-stock_image" *ngIf="!item.Image">
                        <span class="fw-bold fs-4">{{ item.Source?.charAt(0) }}</span>
                     </div>
                  </div>
                  <div class="stocks__news-links">
                     <div class="content">
                        <h2 class="stock__title">
                           {{ item.Source }} |
                           {{ item.Datetime * 1000 | date : "dd MMM YYYY, HH:mm a" }}
                        </h2>
                        <div class="stock_body stock__body-pc">
                           <a href="{{ item.Url }}" target="_blank">{{
                              item.Headline
                           }}</a>
                        </div>
         
                        <div class="stock_body stock__body-mobile">
                           <a href="{{ item.Url }}" target="_blank">{{
                              item.Headline
                           }}</a>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="table__show-more p-3 d-lg-none" *ngIf="news?.length > 5" (click)="showNews = !showNews">
                  <span>{{ showNews ? 'View Less' : 'View All' }}</span>
               </div>
            </ng-container>
            <div *ngIf="!newsLoader && !news?.length">
               <p class="mb-0 text-center py-3">No news available for this stock</p>
            </div>
         </ng-container>

         <ng-container *ngIf="!isMobile">
            <div class="row px-4 pb-3" *ngIf="newsLoader">
               <div class="col-12 pt-3 col-md-6 col-lg-4" *ngFor="let n of [1,2,3,4,5,6]">
                  <ngx-skeleton-loader count="1" appearance="line" animation="progress" [theme]="{ height: '150px', width: '100%', margin: '0px'}"></ngx-skeleton-loader>
               </div>
            </div>
            <div class="desktop-stock-grid" *ngIf="!newsLoader && news?.length">
               <ng-container *ngFor="let item of news">
                  <a [href]="item.Url" target="_blank"  rel="noreferrer noopener" class="text-decoration-none border rounded overflow-hidden news-card">
                     <article class="">
                        <div class="border-bottom">
                           <img [src]="item.Image" [alt]="item.Headline" class="article-image img-fluid" *ngIf="item.Image">
                           <div class="d-flex flex-column align-items-center justify-content-center no-img-wrapper" *ngIf="!item.Image">
                              <img src="/assets/images/news-icon.svg" alt="News Icon" class="no-img img-fluid">
                              <p class="mb-0 fw-bold news-source">{{ item.Source }}</p>
                           </div>
                        </div>
                        <p class="article-date py-2 px-3 mb-0">{{ item.Source }} | {{ item.Datetime * 1000 | date : "dd MMM YYYY, HH:mm a" }}</p>
                        <h5 class="article-headline px-3 pb-3 mb-0">{{ item.Headline }}</h5>
                     </article>
                  </a>
               </ng-container>
            </div>
            <div *ngIf="!newsLoader && !news?.length">
               <p class="mb-0 text-center py-3">No news available for this stock</p>
            </div>
         </ng-container>
      </div>
      
   </div>
</div> -->
